import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _get from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/colorgrid/colorgrid
 */
import View from "../view";
import ColorTileView from "./colortileview";
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import FocusCycler from "../focuscycler";
import KeystrokeHandler from '@ckeditor/ckeditor5-utils/src/keystrokehandler';
import "../../theme/components/colorgrid/colorgrid.css";
/**
 * A grid of {@link module:ui/colorgrid/colortile~ColorTileView color tiles}.
 *
 * @extends module:ui/view~View
 */

var ColorGridView =
/*#__PURE__*/
function (_View) {
  _inherits(ColorGridView, _View);

  /**
   * Creates an instance of a color grid containing {@link module:ui/colorgrid/colortile~ColorTileView tiles}.
   *
   * @param {module:utils/locale~Locale} [locale] The localization services instance.
   * @param {Object} options Component configuration
   * @param {Array.<module:ui/colorgrid/colorgrid~ColorDefinition>} [options.colorDefinitions] Array with definitions
   * required to create the {@link module:ui/colorgrid/colortile~ColorTileView tiles}.
   * @param {Number} options.columns A number of columns to display the tiles.
   */
  function ColorGridView(locale, options) {
    var _this;

    _classCallCheck(this, ColorGridView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColorGridView).call(this, locale));
    var colorDefinitions = options && options.colorDefinitions || [];
    var viewStyleAttribute = {};

    if (options && options.columns) {
      viewStyleAttribute.gridTemplateColumns = "repeat( ".concat(options.columns, ", 1fr)");
    }
    /**
     * The color of the currently selected color tile in {@link #items}.
     *
     * @observable
     * @type {String}
     */


    _this.set('selectedColor');
    /**
     * Collection of the child tile views.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */


    _this.items = _this.createCollection();
    /**
     * Tracks information about DOM focus in the grid.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker}
     */

    _this.focusTracker = new FocusTracker();
    /**
     * Instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
     *
     * @readonly
     * @member {module:utils/keystrokehandler~KeystrokeHandler}
     */

    _this.keystrokes = new KeystrokeHandler();
    /**
     * Helps cycling over focusable {@link #items} in the grid.
     *
     * @readonly
     * @protected
     * @member {module:ui/focuscycler~FocusCycler}
     */

    _this._focusCycler = new FocusCycler({
      focusables: _this.items,
      focusTracker: _this.focusTracker,
      keystrokeHandler: _this.keystrokes,
      actions: {
        // Navigate grid items backwards using the arrowup key.
        focusPrevious: 'arrowleft',
        // Navigate grid items forwards using the arrowdown key.
        focusNext: 'arrowright'
      }
    });

    _this.items.on('add', function (evt, colorTile) {
      colorTile.isOn = colorTile.color === _this.selectedColor;
    });

    colorDefinitions.forEach(function (item) {
      var colorTile = new ColorTileView();
      colorTile.set({
        color: item.color,
        label: item.label,
        tooltip: true,
        hasBorder: item.options.hasBorder
      });
      colorTile.on('execute', function () {
        _this.fire('execute', {
          value: item.color,
          hasBorder: item.options.hasBorder,
          label: item.label
        });
      });

      _this.items.add(colorTile);
    });

    _this.setTemplate({
      tag: 'div',
      children: _this.items,
      attributes: {
        class: ['ck', 'ck-color-grid'],
        style: viewStyleAttribute
      }
    });

    _this.on('change:selectedColor', function (evt, name, selectedColor) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _this.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          item.isOn = item.color === selectedColor;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });

    return _this;
  }
  /**
   * Focuses the first focusable in {@link #items}.
   */


  _createClass(ColorGridView, [{
    key: "focus",
    value: function focus() {
      if (this.items.length) {
        this.items.first.focus();
      }
    }
    /**
     * Focuses the last focusable in {@link #items}.
     */

  }, {
    key: "focusLast",
    value: function focusLast() {
      if (this.items.length) {
        this.items.last.focus();
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(ColorGridView.prototype), "render", this).call(this); // Items added before rendering should be known to the #focusTracker.


      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;
          this.focusTracker.add(item.element);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.items.on('add', function (evt, item) {
        _this2.focusTracker.add(item.element);
      });
      this.items.on('remove', function (evt, item) {
        _this2.focusTracker.remove(item.element);
      }); // Start listening for the keystrokes coming from #element.

      this.keystrokes.listenTo(this.element);
    }
  }]);

  return ColorGridView;
}(View);
/**
 * A color definition used to create a {@link module:ui/colorgrid/colortile~ColorTileView}.
 *
 *		{
 *			color: hsl(0, 0%, 75%),
 *			label: 'Light Grey',
 *			options: {
 *				hasBorder: true
 *			}
 *		}
 *
 * @typedef {Object} module:ui/colorgrid/colorgrid~ColorDefinition
 * @type Object
 *
 * @property {String} color String representing a color.
 * It is used as value of background-color style in {@link module:ui/colorgrid/colortile~ColorTileView}.
 * @property {String} label String used as label for {@link module:ui/colorgrid/colortile~ColorTileView}.
 * @property {Object} options Additional options passed to create a {@link module:ui/colorgrid/colortile~ColorTileView}.
 * @property {Boolean} options.hasBorder A flag that indicates if special a CSS class should be added
 * to {@link module:ui/colorgrid/colortile~ColorTileView}, which renders a border around it.
 */


export { ColorGridView as default };